export default __webpack_public_path__ + "static/media/next-btn.24c0d746.svg";